/* eslint-disable import/no-cycle */
import React from 'react'

import { Image } from '..'
import { Content, Heading, Kicker } from '../Typography'
import {
  kickerMargin,
  mobileCardImage,
  titleMargin,
} from './AccordionItem.module.css'

const AccordionContent = ({
  content,
  image,
  items,
  kicker,
  text,
  textarea,
  title,
  withKicker,
  withTitle,
}) => {
  return (
    <>
      {image && (
        <Image
          alt={image.altText || 'Kliniken Image'}
          className={mobileCardImage}
          src={image.node.localFile.childImageSharp}
        />
      )}
      {withKicker && kicker && (
        <Kicker extraClassName={kickerMargin}>{kicker}</Kicker>
      )}
      {withTitle && title && (
        <Heading extraClassName={titleMargin}>{title}</Heading>
      )}
      {content && <Content renderContent={content} />}
      {text && <p>{text}</p>}
      {textarea && <p>{textarea}</p>}
      {items && items.map((subItem) => subItem)}
    </>
  )
}

export default AccordionContent
